import moment from "moment";
import { formatPrice } from "../../../common/formatPrice";
export function GET_ORDERS_REQUEST(state) {
  state;
  state.orders = {
    ...state.orders,
    isLoading: true,
  };
}
export function GET_ORDERS_SUCCESS(state, payload) {
  let data = [];
  const { orders, meta } = payload.data.data;
  orders
    .filter((item) => item.orgType == "order")
    .map((item) => {
      let branchCodeData, paymentTerm;
      if (item.paymentTerm === "BT") {
        paymentTerm = "Bank Transfer";
      } else if (
        ["COD-CASH", "COD-GIRO", "OD-CASH", "OD-GIRO", "COD", "OD"].includes(
          item.paymentTerm
        )
      ) {
        paymentTerm = "COD";
      } else if (
        [
          "CR-CASH",
          "CR-GIRO",
          "TOP-CASH",
          "TOP-GIRO",
          "TOP",
          "CR",
          "CN",
        ].includes(item.paymentTerm)
      ) {
        paymentTerm = "TOP";
      }
      if (item.branchCodeData) {
        branchCodeData = item.branchCodeData.branch;
      }
      data.push({
        branchCodeData: branchCodeData || "-",
        orderId: item.orderId || "-",
        oracleCustomerId: item.oracleCustomerId || "-",
        status: item.orderStatus || "-",
        paymentStatus: item.payment ? item.payment.status : "-",
        customerName: item.user.customerName || "-",
        customerId: item.user.customerId || "-",
        paymentMethod: paymentTerm || "-",
        totalValue: formatPrice(item.total) || "-",
        created: moment(item.createdAt).format("DD-MM-YYYY HH:mm:ss") || "-",
        updated: moment(item.updatedAt).format("DD-MM-YYYY HH:mm:ss") || "-",
      });
      return item;
    });
  state;
  state.orders = {
    data: data,
    count: meta.total_data,
    status: payload.data.data.status,
    isLoading: false,
  };
}
export function GET_ORDERS_ERROR(state, payload) {
  state;
  state.orders = {
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}

export function GET_ORDER_REQUEST(state) {
  state;
  state.order = {
    ...state.order,
    isLoading: true,
  };
}
export function GET_ORDER_SUCCESS(state, payload) {
  const { order, payment, shipTo, billTo, branchCodeData } = payload.data.data;
  const totalPromoCart = order.discount
    .filter((item) => item.discountType === "cart")
    .reduce((p, c) => p + c.discAmount, 0);
  const totalPromoPaymentMethod = order.discount
    .filter((item) => item.discountType === "payment_method")
    .reduce((p, c) => p + c.discAmount, 0);
  let titlePromoCart, titlePromoPaymentMethod;
  order.discount.map((item) => {
    if (item.discountType === "cart") {
      titlePromoCart = item.title;
    } else if (item.discountType === "payment_method") {
      titlePromoPaymentMethod = item.title;
    }
    return item;
  });
  const tempOrderDetail = [];
  order.orderDetail.rows.map((item) => {
    const itemDiscount = item.discount || [];
    const discountAmount = itemDiscount.reduce((p, c) => p + c.discAmount, 0);
    const totalPromoLines = itemDiscount
      .filter((subItem) => subItem.discountType === "lines")
      .reduce((p, c) => p + c.discAmount, 0);
    const totalPromoStrata = itemDiscount
      .filter((subItem) => subItem.discountType === "strata")
      .reduce((p, c) => p + c.discAmount, 0);
    const totalPromoVoucher = itemDiscount
      .filter((subItem) => subItem.discountType === "voucher")
      .reduce((p, c) => p + c.discAmount, 0);
    tempOrderDetail.push({
      itemName: item.itemName,
      uomCode: item.uomCode || '-',
      ppn: item.ppn || '-',
      qty: item.qty || '-',
      itemPrice: `Rp. ${formatPrice(item.price || 0)}`,
      netPrice: `Rp. ${formatPrice(item.netPrice || 0)}`,
      amtIncludeTax: `Rp. ${formatPrice(item.amtIncludeTax || 0)}`,
      amtAfterDiscount: `Rp. ${formatPrice(item.amtAfterDiscount || 0)}`,
      totalPromoLines: `Rp. ${formatPrice(totalPromoLines)}`,
      totalPromoStrata: `Rp. ${formatPrice(totalPromoStrata)}`,
      totalPromoVoucher: `Rp. ${formatPrice(totalPromoVoucher)}`,
      discountAmount: `Rp. ${formatPrice(discountAmount)}`,
      taxAmount: `Rp. ${formatPrice(item.taxAmount || 0)}`,
    });
  });
  let imageBuktiTransfer = "";
  let paymentNotes = "";
  let paymentAmount = 0;
  let branch;
  let paymentCode;
  if (payment) {
    if (payment.bankAccountCustomer) {
      if (payment.bankAccountCustomer.paymentSlipUrl) {
        imageBuktiTransfer = payment.bankAccountCustomer.paymentSlipUrl;
        paymentNotes = payment.bankAccountCustomer.notes;
        paymentAmount = payment.bankAccountCustomer.paymentAmount || 0;
      }
    }
    if (payment.paymentCode === "BT") {
      paymentCode = "Bank Transfer";
    } else if (
      payment.paymentCode === "OD-GIRO" ||
      payment.paymentCode === "OD-CASH" ||
      payment.paymentCode === "OD"
    ) {
      paymentCode = "COD";
    } else if (
      payment.paymentCode === "CR-GIRO" ||
      payment.paymentCode === "CR-CASH" ||
      payment.paymentCode === "CR"
    ) {
      paymentCode = "TOP";
    }
  }
  if (branchCodeData) {
    branch = branchCodeData.branch;
  }
  const data = {
    branchCodeData: branch || "-",
    orderStatus: order.orderStatus,
    orderCreatedAt: moment(order.orderDate).format("DD MMMM YYYY hh:mm:ss"),
    paymentCode: paymentCode || "-",
    paymentValue: payment ? `Rp. ${formatPrice(payment.billAmount)}` : "-",
    paymentAmount: `Rp. ${formatPrice(paymentAmount)}`,
    paymentNote: paymentNotes,
    orderDetail: [...tempOrderDetail],
    countOrderDetail: order.orderDetail.count || 0,
    subTotal: `Rp. ${formatPrice(order.subTotal)}`,
    totalPromoCart: `Rp. ${formatPrice(totalPromoCart)}`,
    totalPromoPaymentMethod: `Rp. ${formatPrice(totalPromoPaymentMethod)}`,
    titlePromoCart: titlePromoCart || "-",
    titlePromoPaymentMethod: titlePromoPaymentMethod || "-",
    subTotalAfterPromo: `Rp. ${formatPrice(
      order.subTotal - totalPromoCart - totalPromoPaymentMethod
    )}`,
    taxRate: `Rp. ${formatPrice(order.taxRate)}`,
    total: `Rp. ${formatPrice(order.total)}`,
    oracleCustomerId: order.oracleCustomerId,
    orderId: order.orderId,
    paymentId: payment ? payment._id : "-",
    discount: order.discount.map((item) => {
      return {
        description: item.description,
        discountId: item.discountId,
        discountType: item.discountType,
        discAmount: `Rp. ${formatPrice(item.discAmount)}`,
      };
    }),
    ship_to: {
      country: shipTo.country,
      province: shipTo.province,
      city: shipTo.city,
      state: shipTo.state,
      address: shipTo.address,
      postal_code: shipTo.postalCode,
      phone_number: shipTo.primaryPhoneNumber,
      contact_person: shipTo.contactPerson,
      contact_phone_number: shipTo.contactPhoneNumber,
    },
    bill_to: {
      country: billTo.country,
      province: billTo.province,
      city: billTo.city,
      state: billTo.state,
      address: billTo.address,
      postal_code: billTo.postalCode,
      phone_number: billTo.primaryPhoneNumber,
      contact_person: billTo.contactPerson,
      contact_phone_number: billTo.contactPhoneNumber,
    },
    shipping: {
      status: payment ? payment.status : "-",
      estimateArrival: payment ? payment.estimateArrival || "-" : "-",
    },
    imageBuktiTransfer: imageBuktiTransfer,
  };
  state;
  state.order = {
    data: data,
    status: payload.status,
    isLoading: false,
  };
}
export function GET_ORDER_ERROR(state, payload) {
  state;
  state.order = {
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}

export function CREATE_ORDER_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function CREATE_ORDER_SUCCESS(state, payload) {
  state;
  state.orders = [...state.orders, payload.results.data];
  state.isLoading = false;
}
export function CREATE_ORDER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function EDIT_ORDER_REQUEST(state) {
  state;
  state.order = {
    ...state.order,
    isLoading: true,
  };
}
export function EDIT_ORDER_SUCCESS(state, payload) {
  state;
  state.order = {
    ...state.order,
    isLoading: false,
    error: false,
    errorMessage: "",
    data: {
      ...state.order.data,
      orderStatus: payload.data.data.orderUpdate.data.orderStatus,
    },
  };
}
export function EDIT_ORDER_ERROR(state, payload) {
  state;
  state.order = {
    ...state.order,
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}

export function DELETE_ORDER_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function DELETE_ORDER_SUCCESS(state, payload) {
  let index = state.orders.findIndex((item) => item.id == payload.id);
  state.orders.splice(index, 1);
  state;
  state.orders;
  state.isLoading = false;
}
export function DELETE_ORDER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_QRCODE_REQUEST(state) {
  state;
  state.qrCode = {
    ...state.qrCode,
    error: null,
    isLoading: true,
  };
}
export function GET_QRCODE_SUCCESS(state, payload) {
  state;
  state.qrCode = {
    data: payload.data.message || payload.data.data.qr,
    status: payload.status,
    isLoading: false,
    error: false,
  };
}
export function GET_QRCODE_ERROR(state, payload) {
  state;
  state.qrCode = {
    ...state.qrCode,
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}
